import {Directive, HostBinding} from '@angular/core';
import {Toast} from 'primeng/toast';

@Directive({
    selector: 'p-toast',
    standalone: false
})
export class PwcToastDirective {
    constructor(toast: Toast) {
        toast.position = "bottom-right";
    }
}